import React from "react";

import { CardButtons } from "./card-buttons";
import { useCardContext } from "./card-provider";
import clsx from "clsx";

export function CardForeground() {
  const { useFieldValue } = useCardContext();

  const layout = useFieldValue("layout");
  const placement = useFieldValue("placement");
  const title = useFieldValue("title");
  const subtitle = useFieldValue("subtitle");

  switch (layout?.value) {
    case "CTA":
      return (
        <div className="pointer-events-none absolute inset-0 z-20 flex flex-col items-start justify-end gap-4 p-6 group-ui-[dark]/card:text-neutrals-white group-ui-[light]/card:text-neutrals-black">
          <div className="whitespace-pre-line">
            {!title?.value ? null : <p className="h4">{title.value}</p>}
            {!subtitle?.value ? null : <p className="">{subtitle.value}</p>}
          </div>
          <CardButtons />
        </div>
      );
    case "Story":
      return (
        <div className="pointer-events-none absolute inset-0 z-20 flex items-end gap-6 p-6 group-ui-[dark]/card:text-neutrals-white group-ui-[light]/card:text-neutrals-black">
          <div className="flex flex-col gap-2 whitespace-pre-line">
            {!title?.value ? null : <p className="h4 whitespace-pre-line">{title.value}</p>}
            {!subtitle?.value ? null : <p className="whitespace-pre-line">{subtitle.value}</p>}
          </div>
          <CardButtons />
        </div>
      );
    case "Large":
    case "Small":
      return (
        <div
          className={clsx(
            "pointer-events-none absolute inset-0 z-20 flex flex-col gap-4 px-6 py-8 group-ui-[dark]/card:text-neutrals-white group-ui-[light]/card:text-neutrals-black",
            placement?.value === "Top Left" && "items-start justify-start text-left",
            placement?.value === "Top Middle" && "items-center justify-start text-center",
            placement?.value === "Top Right" && "items-end justify-start text-right",
            placement?.value === "Middle Left" && "items-start justify-center text-left",
            placement?.value === "Middle" && "items-center justify-center text-center",
            placement?.value === "Middle Right" && "items-end justify-center text-right",
            placement?.value === "Bottom Left" && "items-start justify-end text-left",
            placement?.value === "Bottom Middle" && "items-center justify-end text-center",
            placement?.value === "Bottom Right" && "items-end justify-end text-right",
            placement?.value === "Stretch Left" && "items-start justify-stretch text-left",
            placement?.value === "Stretch Middle" && "items-center justify-stretch text-center",
            placement?.value === "Stretch Right" && "items-end justify-stretch text-right",
          )}
        >
          <div className="flex flex-col gap-2 whitespace-pre-line">
            {!title?.value ? null : <p className="d3">{title.value}</p>}
            {!subtitle?.value ? null : <p className="">{subtitle.value}</p>}
          </div>
          <div className="hidden group-ui-[stretch]/card:block group-ui-[stretch]/card:grow" />
          <CardButtons />
        </div>
      );
    default:
  }
}
